import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "spr-youtube",
  "use": "spr-youtube-usage",
  "viewBox": "0 0 18.07 12.67",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18.07 12.67\" id=\"spr-youtube\"><defs><style>#spr-youtube .cls-1{fill:#555a5e}</style></defs><title>youtube</title><g id=\"spr-youtube_Слой_2\" data-name=\"Слой 2\"><g id=\"spr-youtube_Слой_1-2\" data-name=\"Слой 1\"><path id=\"spr-youtube_uz1ya\" class=\"cls-1\" d=\"M17.89 2.73a27.35 27.35 0 0 1 .18 2.92V7a27 27 0 0 1-.18 2.91 4 4 0 0 1-.72 1.8 2.62 2.62 0 0 1-1.8.75c-2.54.19-6.33.2-6.33.2s-4.7 0-6.15-.19a3.07 3.07 0 0 1-2-.77 3.94 3.94 0 0 1-.7-1.79A25.64 25.64 0 0 1 0 7V5.65a27.35 27.35 0 0 1 .18-2.92A3.94 3.94 0 0 1 .9.94 2.62 2.62 0 0 1 2.71.18C5.24 0 9 0 9 0s3.8 0 6.33.18a2.6 2.6 0 0 1 1.81.76 4 4 0 0 1 .72 1.8zm-5.84 3.42L7.17 3.61v5.06z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./i/sprite/youtube.svg
// module id = 285
// module chunks = 0